<template>
<CRow>
    <CCol col="12" class="px-3">
        <h5>کانورژن چیست؟</h5>
        <p>کانورژن همان عملی است که به دلیل آن فروشگاه به بازاریاب کمیسیون را پرداخت کرده است. برای مثال زمانی که فروشگاه مشخص کرده باشد در ازی هر خرید 10 درصد کمیسیون پرداخت می‌کند، هنگامی که خریدی از طرف بازاریاب رخ می‌دهد؛ می‌گوییم یک کانورژن از نوع خرید اتفاق افتاده است. </p>
        <h5>چه زمان کمیسیون کانورژن به حساب من واریز می‌شود؟</h5>
        <p v-html="conversionCalculateNotice"></p>
    </CCol>
</CRow>
</template>

<script>
export default {
    name: 'Hint',

    computed: {
        conversionCalculateNotice() {
            const calculateNoticeTime = `<span class="font-weight-bold text-danger">${this.$t('conversion.calculate_time')}</span>`

            return this.$t('conversion.calculate_notice', {time: calculateNoticeTime})
        },
    }
}
</script>